<template>
  <div>
    <!--头部-->
    <div class="storeIncome__head">
      <div class="head__title"><p>累计成交额(元)</p><div class="fs_24 bold">{{order_total?order_total:0}}</div></div>
      <div class="flex_center head__subtitle">
        <div><p>累计分成收入(元)</p><div class="bold">{{ok_income?ok_income:0}}</div></div>
        <div><p>可提现分成收入(元)</p><div class="bold">{{ok_commission?ok_commission:0}}</div></div>
      </div>
    </div>
    <van-cell title="提现" icon=" iconfont icon-jine col_45B9BC fs_20" title-class="fs_15" :value="ok_commission?ok_commission:0" value-class="col_45B9BC fs_15 fw_500" is-link :border="false"  @click="withdrawal()" />
    <div class="storeIncome__list_title">收支明细</div>
    <van-tabs v-model="active" line-height="2px" color="#45B9BC" title-active-color="#45B9BC" @click="change_tab()" sticky>
      <van-tab title="分成收入">
        <van-list v-model="income_loading" :finished="income_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="income__list bb_1" v-for="(item,index) in income_list" :key="index">
            <div class="flex income__list_title"><div>{{item.servicetitle}}</div><div class="fs_18 fw_500 col_45B9BC">￥{{item.income_price}}</div></div>
            <div class="flex fs_12 col_999"><div class="fs_13 col_666">￥{{item.price}}</div><div>{{item.finishtime}}</div></div>
          </div>
        </van-list>
      </van-tab>
      <van-tab title="提现明细">
        <van-list v-model="withdraw_loading" :finished="withdraw_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="income__list bb_1" v-for="(item,index) in withdrawal_list" :key="index">
            <div class="flex income__list_title"><div>{{item.title}}</div><div class="fs_18 fw_500 col_45B9BC">{{item.price}}</div></div>
            <div class="flex fs_12 col_999">
              <div>{{item.apply_time}}</div>
              <div class="fs_13" v-if='item.status==0'>待审核</div>
              <div class="fs_13" v-if='item.status==1'>待打款</div>
              <div class="fs_13" v-if='item.status==3'>提现驳回</div>              
              <div v-if='item.status==2' class="fs_13 col_EA6953">提现成功</div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
  export default {
    name: "store_income",
    data(){
      return{
        store_id:0,
        active:0,
        order_total:0,
        ok_commission:0,
        ok_income:0,
        income_loading: false,
        income_finished: false,
        withdraw_loading: false,
        withdraw_finished: false,
        withdrawal_list_total:0,
        income_list_total:0,
        incomeList_page: 0,
        withdrawList_page: 0,
        store_withdrawal_condition:0,
        income_list:[
          // {item_title:'全身理疗',item_price:'¥160.00',income_price:'+100.00',income_date:'2019-09-08   17:30'},
          // {item_title:'推油养生',item_price:'¥160.00',income_price:'+100.00',income_date:'2019-09-08   17:30'},
        ],
        withdrawal_list:[
          // {type:0,item_title:'提现',withdraw_price:'100.00',withdraw_date:'2019-09-08   17:30',withdraw_state:'待审核'},
          // {type:1,item_title:'提现',withdraw_price:'100.00',withdraw_date:'2019-09-08   17:30',withdraw_state:'待打款'},
          // {type:2,item_title:'提现',withdraw_price:'100.00',withdraw_date:'2019-09-08   17:30',withdraw_state:'提现成功'},
        ],
      }
    },
    created() {
      this.store_id = this.$route.query.store_id
      this.get_store_income();
    },
    methods:{
      get_store_income(){
        var data= {
            store_id:this.store_id,
            incomeList_page: this.incomeList_page,
            withdrawList_page: this.withdrawList_page,
          }
        this.axios({
          url: this.api.store.store_income,
          data: data
        }).then(res => {
          if (res.error === 0) {                       
            this.order_total = res.order_total
            this.ok_commission = res.ok_commission
            this.ok_income = res.ok_income
            this.income_list_total = res.income_list_total
            this.withdrawal_list_total  =res.withdrawal_list_total
            this.incomeList_page = res.incomeList_page
            this.withdrawList_page  =res.withdrawList_page
            this.store_withdrawal_condition = res.store_withdrawal_condition
            var that  =this;
            
            for(let i=0;i<res.income_list.length;i++){
              that.income_list.push(res.income_list[i])
            }
            for(let j=0;j<res.withdrawal_list.length;j++){
              that.withdrawal_list.push(res.withdrawal_list[j])
            }
            // 加载状态结束
           this.income_loading = false;
            if ( this.income_list.length >= this.income_list_total) {
               this.income_loading  =false
              this.income_finished = true
            }
       
             // 加载状态结束
             this.withdraw_loading = false;
            if ( this.withdrawal_list.length >= this.withdrawal_list_total) {
               this.withdraw_loading  =false
               this.withdraw_finished = true
            }

          }
         
        });        
      },
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
            if (this.active==0){          
              if (  this.income_list.length >= this.income_list_total) {
                this.income_finished = true
              }else{
                  this.incomeList_page =parseInt(this.incomeList_page)+1;         
                  this.get_store_income();
              }

            }else if (this.active==1){
              // 加载状态结束
              if ( this.withdrawal_list.length >= this.withdrawal_list_total) {
                this.withdraw_finished = true
              }else{
                  this.withdrawList_page = parseInt(this.withdrawList_page)+1;         
                  this.get_store_income();
              }
            }
        },500);          
          
      },
      withdrawal(){
        if(this.ok_commission>0){
          if(this.store_withdrawal_condition>this.ok_commission){
             this.$toast({
              message:"可提现收入满"+this.store_withdrawal_condition+"才能提现",
              duration:1500,
            });
            return;
          }
           this.$router.push({path:"/store_withdrawal",query:{store_id:this.store_id}});
        }else{
           this.$toast("提现金额不足");
        }
      },
       change_tab(){
          this.incomeList_page = 0;
          this.withdrawList_page = 0;
          this.income_list  =[];
          this.withdrawal_list = [];
          this.income_finished  =false;
          this.withdraw_finished  =false;
          this.get_store_income();
      },
    },
  }
</script>

<style scoped>
  .storeIncome__head{
    background: linear-gradient(#6C8ED4, #45B9BC);
    background:  -webkit-linear-gradient(#6C8ED4, #45B9BC);
    color: #fff;
    padding: .75rem;
    text-align: center;
    font-size: .75rem;
  }
  .head__title{
    padding: 1rem 0 1.5rem;
  }
  .head__title p,.head__subtitle p{
    font-size: .65rem;
    color: rgba(255,255,255,.6);
    line-height: 1rem;
  }
  .head__subtitle>div{
    width: 100%;
  }
  /*收支明细*/
  .storeIncome__list_title{
    font-size: .75rem;
    color: #333;
    padding: .5rem .75rem;
    margin-top: .25rem;
  }
  .income__list{
    background: #fff;
    font-size: .75rem;
    color: #333;
    padding: .6rem .75rem;
  }
  .income__list_title{
    line-height: 1.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/views/store/store_income.vue